import { isFeatureEnabled } from 'owa-feature-flags';
import isCalendarHelpSubscriber from './isCalendarHelpSubscriber';

export default function isCalendarHelpEnabled(): boolean {
    const featureEnabled = isFeatureEnabled('mc-smartReplyWithMeeting-Cortana');
    const calendarHelpSubscriber = isCalendarHelpSubscriber();

    return featureEnabled && calendarHelpSubscriber;
}
